app.service('allAccesoriesModal', function (loading, modal, simpleToastr, scroll, broker,
	pageConfig, basketAnalytics, lazyLoad, log, productDetailsModal, cartManager) {
	const allAccessoriesModalId = `show-all-product-accessories`;
	let $self, $generatedModal;
	let config = {};
	let productsInCart = {};
	let parent, parentId, parentPlu, parentLinkName;
	let $menu, $list, $menuTabsBox;
	let menuTabsData = [], overflowedMenuElementsCount = 0;
	var isInit = false, accessoryInteraction = false;

	function open(productId, productLinkName) {
		config = pageConfig.getData('basket');
		productsInCart = config.items.map(item => item.id);
		parentId = productId;
		parentLinkName = productLinkName;
		parent = config.items.filter(function (e) {
			return e.id == productId;
		});
		if (parent.length) {
			parent = parent[0];
			parentPlu = parent.plu;
		}
		loading.start();
		$.ajax({
			url: '/product-card-access-in-cart.ltr',
			data: {
				'product-link-name': productLinkName
			},
			success: function (html) {
				loading.stop();

				$generatedModal = modal.generate({
					id: allAccessoriesModalId,
					content: html,
					callbackClose: function () {
						refreshOnCallback();
					}
				});

				// setting elements and adding events
				$self = $generatedModal.$modal;
				$menu = $('.js-accessory-group', $self);
				$list = $('.accessory-list', $self);
				$menuTabsBox = $('.accessory-groups ul', $self);
				checkProductsInCart();
				setMenuTabsInfo();
				setAccessoryListOverflowInfo();
				setEvents();
				setHeight($list.first());
				lazyLoad.update();
			},
			error: function () {
				loading.stop();
				modal.alert('Błąd generowania warstwy akcesorii', function () {
					refreshOnCallback();
				});
			}
		});
	}

	function selectAccessoriesGroup(groupId) {
		$menu.removeClass('active prev-active');
		$menu.filter(`[data-group="${groupId}"]`).addClass('active').prev().addClass('prev-active');
		const isGroupLoaded = menuTabsData.find(tab => tab.groupId == groupId).listLoaded;
		$self.addClass('loading');
		if (!isGroupLoaded) {
			$.ajax({
				url: '/product-card-access-in-cart.ltr',
				data: {
					'product-link-name': parentLinkName,
					'group-id': groupId
				},
				success: function (html) {
					$list.filter(`[data-group="${groupId}"]`).html(html);
					menuTabsData.find(tab => tab.groupId == groupId).listLoaded = true;
					$self.removeClass('loading');
					showActiveAccessoriesList(groupId);
				},
				error: function () {
					$self.removeClass('loading');
					modal.alert('Błąd generowania warstwy akcesorii', function () {
						refreshOnCallback();
					});
				}
			});
		} else {
			$self.removeClass('loading');
			showActiveAccessoriesList(groupId);
		}
	}

	function refreshOnCallback() {
		if (accessoryInteraction) {
			broker.trigger('REFRESH_BASKET_VIEW');
			accessoryInteraction = false;
		}
	}

	function showActiveAccessoriesList(groupId) {
		$list.removeClass('active').removeAttr('data-scroll');
		$list.find('.accessory-box').css('transform', 'translateX(0)');
		let $activeList = $list.filter(`[data-group="${groupId}"]`).addClass('active');
		setAccessoryListOverflowInfo();
		setHeight($activeList);
		lazyLoad.update();
		checkProductsInCart();
	}


	function checkProductsInCart() {
		$('.js-add-accessory-to-cart', $self).each(function () {
			let $element = $(this);
			let id = $element.data('id') / 1
			let checked = $.inArray(id, productsInCart) > -1;
			if (checked) {
				$element.addClass('added-to-cart');
			} else {
				$element.removeClass('added-to-cart');
			}
		});
	}

	function setHeight($activeList) {
		let $content = $activeList.find('.js-accessory-content');
		let minHeight = 0;
		$content.each(function () {
			minHeight = Math.max(minHeight, $(this).height());
		});
		$content.css('height', minHeight);
	}

	function setMenuTabsInfo() {
		const scrollData = $menuTabsBox.attr('data-scroll') / 1 || 0;
		const boxWidth = $menuTabsBox[0].offsetWidth;
		menuTabsData = [];
		overflowedMenuElementsCount = 0;
		$menu.each(function (index, el) {
			menuTabsData.push({
				groupId: el.dataset.group,
				offsetLeft: el.offsetLeft,
				width: el.offsetWidth,
				offsetToRight: el.offsetLeft + el.offsetWidth,
				listLoaded: $list.filter(`[data-group="${el.dataset.group}"]`).html().trim().length > 0,
			})
			if (boxWidth < (el.offsetLeft + el.offsetWidth)) {
				overflowedMenuElementsCount++;
			}
		});
		$menuTabsBox.attr('data-overflowed-elements', overflowedMenuElementsCount > scrollData ? overflowedMenuElementsCount - scrollData : 0);
	}

	function slideMenuTabs(direction) {
		if (overflowedMenuElementsCount >= 0) {
			let scrollData = $menuTabsBox.attr('data-scroll') / 1 || 0;
			direction === 'right' ? scrollData++ : scrollData--;
			$menuTabsBox.attr('data-overflowed-elements', overflowedMenuElementsCount > scrollData ? overflowedMenuElementsCount - scrollData : 0)
			if (scrollData) {
				$menuTabsBox.attr('data-scroll', scrollData);
				$menuTabsBox.css('transform', 'translateX(' + (-1 * menuTabsData[scrollData].offsetLeft) + 'px)');
			} else {
				$menuTabsBox.removeAttr('data-scroll');
				$menuTabsBox.css('transform', 'translateX(0px)');
			}
		}
	}

	function setAccessoryListOverflowInfo() {
		const $activeList = $self.find('.accessory-list.active');
		const $accessoryBox = $activeList.find('.accessory-box');

		const scrollData = $activeList.attr('data-scroll') / 1 || 0;
		const boxWidth = $activeList[0].offsetWidth;
		const boxItemsCount = $accessoryBox[0].children.length;
		const boxItemWidth = $accessoryBox.find('.accessory-item').outerWidth(true); // width with margin
		const boxItemsOutsideView = Math.round((boxItemsCount * boxItemWidth - boxWidth) / boxItemWidth);

		$activeList.attr('data-overflowed-elements', boxItemsOutsideView > scrollData ? boxItemsOutsideView - scrollData : 0);
	}

	function slideAccessory(direction) {
		const $activeList = $self.find('.accessory-list.active');
		const $accessoryBox = $activeList.find('.accessory-box');

		const boxWidth = $accessoryBox[0].offsetWidth;
		const boxItemsCount = $accessoryBox[0].children.length;
		const boxItemWidth = $accessoryBox.find('.accessory-item').outerWidth(true); // width with margin
		const boxItemsOutsideView = Math.round((boxItemsCount * boxItemWidth - boxWidth) / boxItemWidth);

		if (boxItemsOutsideView >= 0) {
			let scrollData = $activeList.attr('data-scroll') / 1 || 0;
			direction === 'right' ? scrollData++ : scrollData--;
			$activeList.attr('data-overflowed-elements', boxItemsOutsideView > scrollData ? boxItemsOutsideView - scrollData : 0);
			if (scrollData) {
				$activeList.attr('data-scroll', scrollData);
				$accessoryBox.css('transform', 'translateX(' + (-1 * scrollData * boxItemWidth) + 'px)');
			} else {
				$activeList.removeAttr('data-scroll');
				$accessoryBox.css('transform', 'translateX(0px)');
			}
		}
	}

	function setEvents() {
		$self.on('click', '.js-k1-product-details', function (event) {
			let product = $(this).data('id') / 1;
			let productPlu = $(this).data('plu');
			let productName = $(this).parents('.accessory-item').find('.accessory-name a').text().trim();
			productDetailsModal.open({
				productId: product,
				productPlu: productPlu,
				parentId: parentId,
				callbackAdded: function () {
					basketAnalytics.addAccessory(productPlu, parentPlu, 'fancybox');
					productsInCart = [product, ...productsInCart];
					modal.close();
					scroll.to({ $element: $('#cart-summarize') });
					simpleToastr.generate(`<h2>Produkt dodany do koszyka</h2><p>${productName}</p>`);
					accessoryInteraction = true;
					checkProductsInCart();
				},
				productDetailsModalClose: function () {
					modal.open(allAccessoriesModalId);
				}
			});
			event.stopPropagation();
			event.preventDefault();
		}).on('click', '.js-accessory-group', function () {
			if (!$(this).is('.active')) {
				let groupId = $(this).data('group');
				selectAccessoriesGroup(groupId);
			}
		}).on('touchend', '.accessory-list', function () {
			lazyLoad.update();
		}).on('click', '.js-slide-accessory-right', function () {
			slideAccessory('right');
			lazyLoad.update();
		}).on('click', '.js-slide-accessory-left', function () {
			slideAccessory('left');
		}).on('click', '.js-slide-menu-tabs-right', function () {
			slideMenuTabs('right')
		}).on('click', '.js-slide-menu-tabs-left', function () {
			slideMenuTabs('left')
		}).on('click', '.js-add-accessory-to-cart', function () {
			accessoryInteraction = true;
			let checked = $(this).is('.added-to-cart');
			let productId = $(this).data('id') / 1;
			let accessoryPlu = $(this).data('plu');
			let productName = $(this).parents('.accessory-item').find('.accessory-name a').text().trim();
			if (!checked) {
				cartManager.simpleAddProduct({
					addedFrom: 'CART_EDIT',
					productId: productId
				}, function () {
					basketAnalytics.addAccessory(accessoryPlu, parentPlu, 'button');
					productsInCart = [productId, ...productsInCart];
					simpleToastr.generate(`<h2>Produkt dodany do koszyka</h2><p>${productName}</p>`);
					checkProductsInCart();
				});
			} else {
				cartManager.removeProduct({
					productId: productId
				}, function () {
					basketAnalytics.removeAccessory(accessoryPlu, parentPlu);
					productsInCart = productsInCart.filter(i => i !== productId);
					checkProductsInCart();
				});
			}
		});

		if (!isInit) {
			$(window).on('resize', function () {
				setMenuTabsInfo();
				setAccessoryListOverflowInfo();
			});
			isInit = true;
		}
	}

	return {
		open
	};
});
